import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import {
  ResetLayoutStateAction,
  SetColorsAction,
  SetLanguageAction,
  ToggleSidebarAction,
} from './layout.meta.actions'
import { ILayoutColors, LayoutMetaStateModel } from './layout.meta.model'

const INITIAL_STATE: LayoutMetaStateModel = {
  config: {
    colors: {
      primary_color: '#E05F57',
      secondary_color: '#f06d6d',
    },
  },
  language: 'en',
  isSidebarOpen: true,
}

@State<LayoutMetaStateModel>({
  name: 'layoutMeta',
  defaults: { ...INITIAL_STATE },
})
@Injectable()
export class LayoutMetaState {
  constructor(private translate: TranslateService) {}

  @Selector()
  public static getState(state: LayoutMetaStateModel): LayoutMetaStateModel {
    return state
  }

  @Selector()
  public static getIsSidebarOpen(state: LayoutMetaStateModel): boolean {
    return state.isSidebarOpen
  }

  @Selector()
  public static getConfigColors(state: LayoutMetaStateModel): ILayoutColors {
    return state.config.colors
  }

  @Selector()
  public static getLanguage(state: LayoutMetaStateModel): string {
    return state.language
  }

  @Action(ResetLayoutStateAction)
  resetState(ctx: StateContext<LayoutMetaStateModel>): void {
    ctx.setState({ ...INITIAL_STATE })
  }

  @Action(SetColorsAction)
  setColors(
    ctx: StateContext<LayoutMetaStateModel>,
    action: SetColorsAction,
  ): void {
    const state = ctx.getState()
    ctx.setState({
      ...state,
      config: {
        ...state.config,
        colors: action.payload,
      },
    })
  }

  @Action(SetLanguageAction)
  setLanguage(
    ctx: StateContext<LayoutMetaStateModel>,
    action: SetLanguageAction,
  ): void {
    ctx.patchState({
      language: action.payload,
    })
    localStorage.setItem('language', action.payload)
    this.translate.use(action.payload)
  }

  @Action(ToggleSidebarAction)
  toggleSidebar(ctx: StateContext<LayoutMetaStateModel>): void {
    const state = ctx.getState()
    ctx.setState({
      ...state,
      isSidebarOpen: !state.isSidebarOpen,
    })
  }
}
